import { AppearanceSwitchModalAction, ModalActionTypes, ModalTypes } from '../types';

export const appearanceSwitchModalAction = (
  cids: number[],
  accept: () => void
): AppearanceSwitchModalAction => ({
  type: ModalActionTypes.SHOW,
  modalType: ModalTypes.APPEARANCE_SWITCH,
  props: { cids, accept },
});
